export default __webpack_public_path__ + "packages/visuals/charts/assets/icon-64.png";